import { useState } from 'react';

import { Grid } from '@mui/material';

import { StepperSidePane } from './StepperSidePane';
import type { TStepperProps } from './types';

export const Stepper = <PId extends string, PData>({
  step,
  steps,
  onFinish,
  sidePaneTitle,
  initialData = {},
  styles,
}: TStepperProps<PId, PData>) => {
  const [data, setData] = useState<Partial<PData>>(initialData);
  const [active, setActive] = useState(() => steps.findIndex(({ id }) => id === step));

  const { Component } = steps[active];

  const moveBack = () => {
    if (active > 0) {
      setActive(active - 1);
    }
  };

  const onSubmit = async (patch?: Partial<PData>) => {
    const result = { ...data, ...patch };

    setData(result);

    if (active < steps.length - 1) {
      setActive(active + 1);
    } else {
      await onFinish(result as PData);
    }
  };

  return (
    <Grid sx={styles.root}>
      <StepperSidePane styles={styles} title={sidePaneTitle} steps={steps} active={active} />
      <Component data={data} onSubmit={onSubmit} moveBack={moveBack} />
    </Grid>
  );
};
